// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__xzB5n","calendarButtons":"ClockData_calendarButtons__3hPQs"};